// Public API

// Re-export useful types from @yak-io/javascript for consumers
export type {
  ChatConfigProvider,
  GraphQLRequest,
  RESTRequest,
  Theme,
  ThemeColors,
  ToolAdapter,
  ToolCallEvent,
  ToolCallHandler,
  TriggerButtonConfig,
  UserIdentity,
  VoiceMachine,
  VoiceState,
  WidgetMode,
  WidgetPosition,
  YakServerAdapterConfig,
  YakToolset,
} from "@yak-io/javascript";
// Re-export tool composition + logging utilities
export {
  createYakServerAdapter,
  createYakToolset,
  disableYakLogging,
  enableYakLogging,
  isYakLoggingEnabled,
} from "@yak-io/javascript";
export type {
  ToolCallEventHandler,
  YakApi,
  YakProviderOptions,
  YakState,
} from "./service.js";
export { createYakProvider } from "./service.js";
